<template>
    <div class="warning">
      <strong>
      {{title}}
      </strong>
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'HighlightBlockWarning',
  props: {
    title: {
      type: String,
      default: 'Note:'
    }
  }
}
</script>

<style lang="scss" scoped>
  .warning {
    background-color: rgba(0, 0, 0, 0.1);
    color: black;
    padding: 15px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HighlightBlockWarning.vue